"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _mixins = _interopRequireDefault(require("../../utils/mixins"));

var _Route = _interopRequireDefault(require("../../Router/Route"));

var _RouteWithIdDecorator = _interopRequireDefault(require("../../Router/RouteWithIdDecorator"));

var _RouteWithPageDecorator = _interopRequireDefault(require("../../Router/RouteWithPageDecorator"));

var _RouteWithConstraintsDecorator = _interopRequireDefault(require("../../Router/RouteWithConstraintsDecorator"));

var _RouteWithParameters = _interopRequireDefault(require("../RouteWithParameters"));

class MyRoute extends (0, _mixins.default)(_Route.default, _RouteWithIdDecorator.default, _RouteWithPageDecorator.default, _RouteWithConstraintsDecorator.default) {
  constructor(...args) {
    super(...args);
    this.RouteWithParameters = _RouteWithParameters.default;
  }

}

exports.default = MyRoute;